import type * as core from '../../../../../../../core'

export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: 'Value of Change',
      type: 'charts',
      content: {
        '{}': {
          data: {
            '[]': [
              {
                '{}': {
                  name: 'Value of Change',
                  values: {
                    '[]': [
                      {
                        '{}': {
                          name: 'Change Impacts',
                          points: {
                            '[]': [
                              {
                                '{}': {
                                  x: 'High',
                                  y: {
                                    '#': {
                                      '@': 'valueHigh',
                                    },
                                  },
                                  onClick: {
                                    '{}': {
                                      action: {
                                        '{}': {
                                          payload: {
                                            '{}': {
                                              goto: {
                                                '{}': {
                                                  variables: {
                                                    '{}': {
                                                      valueOfChange: 'High',
                                                    },
                                                  },
                                                  navigationId:
                                                    'change.impacts',
                                                },
                                              },
                                            },
                                          },
                                          operation: 'ui.navigate',
                                        },
                                      },
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Medium',
                                  y: {
                                    '#': {
                                      '@': 'valueMedium',
                                    },
                                  },
                                  onClick: {
                                    '{}': {
                                      action: {
                                        '{}': {
                                          payload: {
                                            '{}': {
                                              goto: {
                                                '{}': {
                                                  variables: {
                                                    '{}': {
                                                      valueOfChange: 'Medium',
                                                    },
                                                  },
                                                  navigationId:
                                                    'change.impacts',
                                                },
                                              },
                                            },
                                          },
                                          operation: 'ui.navigate',
                                        },
                                      },
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Low',
                                  y: {
                                    '#': {
                                      '@': 'valueLow',
                                    },
                                  },
                                  onClick: {
                                    '{}': {
                                      action: {
                                        '{}': {
                                          payload: {
                                            '{}': {
                                              goto: {
                                                '{}': {
                                                  variables: {
                                                    '{}': {
                                                      valueOfChange: 'Low',
                                                    },
                                                  },
                                                  navigationId:
                                                    'change.impacts',
                                                },
                                              },
                                            },
                                          },
                                          operation: 'ui.navigate',
                                        },
                                      },
                                    },
                                  },
                                },
                              },
                            ],
                          },
                        },
                      },
                    ],
                  },
                },
              },
            ],
          },
          type: 'bar',
        },
      },
    },
  },
  subqueries: {
    valueLow: {
      filter: {
        '=': [
          {
            '@.': '!value_of_change',
          },
          'Low',
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    valueHigh: {
      filter: {
        '=': [
          {
            '@.': '!value_of_change',
          },
          'High',
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    valueMedium: {
      filter: {
        '=': [
          {
            '@.': '!value_of_change',
          },
          'Medium',
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
  },
}
